import styles from './SearchResultsCard.module.css';
import { useRouter } from 'next/router';

const SearchResultsCard = ({ manga }) => {
  const router = useRouter();

  const handleCardClick = () => {
    // router.push(`/manga/${manga.transliterated_name}`);
    router.push(`https://manhvalite.com/manhwa/ms-${manga.transliterated_name}`);
  };

  return (
      <div className={styles.card} onClick={handleCardClick} draggable={false}>
        <div className={styles.cover}>
          <img className={styles.cover_img} src={manga.cover_url} alt="" draggable={false}/>
        </div>
        <div className={styles.info}>
          <p className={styles.card_name}>{manga.name}</p>
          <p className={styles.card_tags}>{manga.type}</p>
        </div>
      </div>
  );
};

export default SearchResultsCard;
